export default __webpack_public_path__ + "static/188-99ca3ec8db87cd2766b9f2ad94e97fb8.jpg";